import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import ErrorLayout from "../AppError/ErrorLayout";

const Maintenance = () => (
	<ErrorLayout>
		<Heading
			Tag="h1"
			sx={{ fontSize: "xl", fontColor: "3", textAlign: "center" }}
			spacing={{ mb: 6 }}
		>
			We’re undergoing maintenance.
		</Heading>
		<Paragraph sx={{ fontSize: "s", textAlign: "center" }}>
			We’re sorry. We’re temporarily unavailable. Please come back later.
		</Paragraph>
	</ErrorLayout>
);

export default Maintenance;
